import LayoutDashboard from "components/LayoutDashboard";
import TransitionalRegion from "components/TransitionalRegion";
import AppLayout from "features/AppLayout";
import { lazy, Suspense } from "react";
import { Outlet, Route } from "react-router-dom";

const ProjectManagement = lazy(() => import("features/ProjectManagement"));
const VideoListing = lazy(
  () => import("features/VideoManagement/VideoListing"),
);
const VideoReview = lazy(() => import("features/VideoManagement/VideoReview"));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Suspense fallback={<TransitionalRegion noResultsText={<></>} />}>
    {children}
  </Suspense>
);

const ViewerRoutes = (
  <>
    <Route
      element={
        <SuspenseWrapper>
          <LayoutDashboard />
        </SuspenseWrapper>
      }
    >
      <Route path="dashboard" element={<ProjectManagement />} />
      <Route path="dashboard/:activeId" element={<ProjectManagement />} />
    </Route>
    <Route
      path="project"
      element={
        <SuspenseWrapper>
          <Outlet />
        </SuspenseWrapper>
      }
    >
      <Route path=":slug" element={<AppLayout />}>
        <Route path="videos/:listingType" element={<VideoListing />} />
        <Route
          path="videos/:listingType/review/:activeId"
          element={<VideoReview />}
        />
        <Route path="videos/:listingType/review" element={<VideoReview />} />
      </Route>
    </Route>
  </>
);

export default ViewerRoutes;
